import type { GeneralConfig } from '@shared/types/Config';

export const publicTransactionConfig: GeneralConfig = {
    sortFieldMap: {
        type: 'transaction_types|name',
        // steward_name: 'stewards|name',
        execution_date: 'date_of_transaction',
    },
};
